import { Play } from "lucide-react";
import type { SoundStylePublic } from "../../../lib/api";

// Card para el selector de estilo de sonido — radio button + label +
// description. Click en cualquier parte de la card selecciona.
// Variant si está seleccionado: borde violeta + fondo tintado.
//
// Extraido de Configuracion (Mi pantalla) para reuso y para adelgazar el
// route. El markup se mueve tal cual.
export function SoundStyleCard({
  style,
  selected,
  onSelect,
  onPreview,
}: {
  style: SoundStylePublic;
  selected: boolean;
  onSelect: () => void;
  onPreview: () => void;
}) {
  // Estructura: contenedor con el boton de seleccion (ocupa casi todo) +
  // un boton de play separado para escuchar el estilo antes de elegir.
  // Botones hermanos (no anidados) para HTML valido.
  return (
    <div
      className={`flex items-center gap-1 rounded-lg border-2 transition ${
        selected
          ? "border-[#a78bfa] bg-[#a78bfa]/10"
          : "border-white/10 hover:bg-white/5"
      }`}
    >
      <button
        type="button"
        onClick={onSelect}
        className="flex flex-1 items-start gap-3 px-3 py-3 text-left"
      >
        <span
          className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
            selected ? "border-[#a78bfa] bg-[#a78bfa]" : "border-white/30"
          }`}
        >
          {selected && (
            <span className="block h-1.5 w-1.5 rounded-full bg-white" />
          )}
        </span>
        <div className="flex-1">
          <div className="text-sm font-medium">{style.label}</div>
          {style.description && (
            <div className="mt-0.5 text-xs opacity-60">{style.description}</div>
          )}
        </div>
      </button>
      <button
        type="button"
        onClick={onPreview}
        title="Escuchar este estilo"
        aria-label={`Escuchar ${style.label}`}
        className="mr-2 shrink-0 rounded-full p-2 text-white/70 transition hover:bg-white/10 hover:text-white"
      >
        <Play className="h-4 w-4" />
      </button>
    </div>
  );
}
